import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    CREATE_HATCH_ANSWER,
    UPDATE_HATCH_ANSWER,
    DELETE_HATCH_ANSWER
} from './constants';
import {
    createAnswerSuccess,
    updateAnswerSuccess,
    deleteAnswerSuccess
} from './actions';

import {
    requestAnswerCreation,
    requestAnswerUpdating,
    requestAnswerDeleting
} from './api' ;

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* createAnswer( actionObj ) {
    const updatedQuestion = yield requestAnswerCreation( actionObj.questionID, actionObj.answer, actionObj.localizationId, actionObj.questionType, actionObj.resolve );

    if ( updatedQuestion ) {
        yield put( createAnswerSuccess( actionObj.questionID, updatedQuestion ) );
    }
}

/**
 *
 * @param questionID
 * @param answerId
 * @param answer
 * @param localizationID
 * @param questionType
 * @param resolve
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* updateAnswer( { questionID, answerId, answer, localizationID, questionType, resolve } ) {

    const updatedQuestion = yield requestAnswerUpdating( questionID,
        answerId,
        answer,
        localizationID,
        questionType,
        resolve );
    if ( updatedQuestion ) {
        yield put( updateAnswerSuccess( questionID, updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questionID, question, type}>>}
 */
function* deleteAnswer( actionObj ) {
    const updatedQuestion = yield requestAnswerDeleting( actionObj.answerId, actionObj.questionType );
    if ( updatedQuestion ) {
        yield put( deleteAnswerSuccess( actionObj.questionID, updatedQuestion ) );
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchHatchAnswers() {
    yield takeEvery( CREATE_HATCH_ANSWER, createAnswer );
    yield takeLatest( UPDATE_HATCH_ANSWER, updateAnswer );
    yield takeLatest( DELETE_HATCH_ANSWER, deleteAnswer );
}

export default watchHatchAnswers;